import { render, staticRenderFns } from "./SurgeryComplications.vue?vue&type=template&id=6b86b3de&scoped=true&"
import script from "./SurgeryComplications.vue?vue&type=script&lang=js&"
export * from "./SurgeryComplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b86b3de",
  null
  
)

export default component.exports